import React, { Component } from 'react';
import Page from '../pages/Page';
import AdministratorContainer from '../containers/Administrator';

class Adminsitrator extends Component {
  getMetaData() {
    return {
      title: this.pageTitle(),
      meta: this.pageMeta(),
      link: this.pageLink()
    };
  }

  pageTitle = () => {
    return 'Administrator Console | Growth-Connections.com';
  };

  pageMeta = () => {
    return [
      { name: 'description', content: 'Administrator' }
    ];
  };

  pageLink = () => {
    return [];
  };

  render() {
    return (
      <Page {...this.getMetaData()}>
        <AdministratorContainer {...this.props} />
      </Page>
    );
  }
}

export default Adminsitrator;




// WEBPACK FOOTER //
// app/pages/Administrator.jsx